import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import { EditLegalRequirementTemplateData } from './EditLegalRequirementTemplateData';
import { useState } from 'react';
import { getEmptyReqTemplate } from '../core/generic_helper';
import { ILegalRequirementTemplateFullObject } from '../Interfaces/ILegalRequirementTemplate';
import { ILegalPhaseTemplateFullObject } from '../Interfaces/ILegalPhaseTemplate';

interface IProps {
  isOpenEditLegalRequirementTemplate: boolean;
  setIsOpenEditLegalRequirementTemplate: Function;
  legalRequirementTemplate?: ILegalRequirementTemplateFullObject;
  updateLegalRequirementTemplateArray: Function;
  currentLegalPhaseTemplate: ILegalPhaseTemplateFullObject;
  legalPhaseTemplateArray?: ILegalPhaseTemplateFullObject[];
}

export const EditLegalRequirementTemplate: React.FC<IProps> = ({
  isOpenEditLegalRequirementTemplate,
  setIsOpenEditLegalRequirementTemplate,
  legalRequirementTemplate,
  updateLegalRequirementTemplateArray,
  currentLegalPhaseTemplate,
  legalPhaseTemplateArray,
}) => {
  const [editLegalRequiremntTemplate, setEditLegalRequirementTemplate] =
    useState<ILegalRequirementTemplateFullObject>(
      legalRequirementTemplate
        ? legalRequirementTemplate
        : getEmptyReqTemplate(currentLegalPhaseTemplate)
    );

  const handleAddNewReq = () => {
    if (legalRequirementTemplate) {
      updateLegalRequirementTemplateArray([
        ...currentLegalPhaseTemplate.LegalRequirementArray.map(x =>
          x.idLegalRequirementTemplate ===
          editLegalRequiremntTemplate.idLegalRequirementTemplate
            ? editLegalRequiremntTemplate
            : x
        ),
      ]);
    } else {
      updateLegalRequirementTemplateArray([
        ...currentLegalPhaseTemplate.LegalRequirementArray,
        editLegalRequiremntTemplate,
      ]);
    }

    setIsOpenEditLegalRequirementTemplate(false);
  };

  return (
    <>
      <Dialog
        open={isOpenEditLegalRequirementTemplate}
        onClose={() => setIsOpenEditLegalRequirementTemplate(false)}
        maxWidth='lg'
        fullWidth
      >
        <DialogTitle
          variant='h5'
          sx={{
            borderBottom: '1px solid #ccc',
          }}
        >
          {legalRequirementTemplate
            ? 'Maßnahme bearbeiten'
            : 'Maßnahme hinzufügen'}
        </DialogTitle>
        <DialogContent>
          <EditLegalRequirementTemplateData
            currentRequirementTemplate={editLegalRequiremntTemplate}
            setCurrentRequirementTemplate={setEditLegalRequirementTemplate}
            legalRequirementTemplates={
              currentLegalPhaseTemplate.LegalRequirementArray
            }
            legalPhaseTemplateArray={legalPhaseTemplateArray}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant='outlined'
            onClick={() => setIsOpenEditLegalRequirementTemplate(false)}
          >
            Abbruch
          </Button>
          <Button
            variant='contained'
            onClick={handleAddNewReq}
            disabled={
              editLegalRequiremntTemplate.LegalRequirementTemplate === ''
            }
          >
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
